import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container-full-1 bg-grey-50" }
const _hoisted_2 = { class: "s20 widget flex align-items-center px-1 py-5" }
const _hoisted_3 = { class: "s2_mobile h-100p px-7" }
const _hoisted_4 = { class: "rounded-100 overflow-hidden item active" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "s4_mobile h-100p px-2" }
const _hoisted_7 = { class: "s3_mobile h-100p px-2" }
const _hoisted_8 = { class: "font-normal mb-5" }
const _hoisted_9 = { class: "s4_mobile h-100p px-3" }
const _hoisted_10 = { class: "font-normal" }
const _hoisted_11 = { class: "text-2xl" }
const _hoisted_12 = { class: "s20 widget px-6 pt-8 pb-2" }
const _hoisted_13 = {
  key: 0,
  class: "s10 mt--5-5 flex-right gap-4"
}
const _hoisted_14 = { class: "s20 items-center gap-6 px-5 pb-4 collapse-content active" }
const _hoisted_15 = { class: "grid4 px-1" }
const _hoisted_16 = { class: "s10" }
const _hoisted_17 = { class: "secondary-font font-semibold mb-1" }
const _hoisted_18 = { class: "secondary-font font-semibold text-grey-900 py-1" }
const _hoisted_19 = { class: "s10 text-right" }
const _hoisted_20 = { class: "secondary-font font-semibold text-primary-color pb-1 display-none" }
const _hoisted_21 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_22 = {
  key: 0,
  class: "s20 mt-2"
}
const _hoisted_23 = {
  key: 1,
  class: "text-center"
}

import { useRoute } from 'vue-router';
    import { inject, ref } from 'vue';
import { formatAmount, formatDateFrench } from '@/utils';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'UsersRevolvingView',
  setup(__props) {

    const BACKEND_URL = inject('BACKEND_URL');
    const route = useRoute();
    const startupinfos: any = route.meta.startup_datas;
    const user: any = startupinfos.user;
    const prelevements: any[] = startupinfos.prelevements;
    const loading = ref(false);
    const errorMessage = ref('');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[18] || (_cache[18] = _createStaticVNode("<div class=\"page-space-40\"></div><h4 class=\"s7 font-semibold px-3 pb-5\">Membre / Revolving <span class=\"text-sm text-grey-500\"></span></h4><div class=\"s13 flex-right gap-3 mt--2 mb-5 px-5\"><span class=\"btn shadow-200 white2\">Souscription</span><span class=\"btn shadow-200 white2\">Contrat</span><span class=\"btn shadow-200 light2 border-none\">Prélèvement</span><span class=\"btn shadow-200 light2 border-none\">Premier prélèvement</span><span class=\"btn shadow-200 light2 border-none\">Décaissement mensuel</span><span class=\"btn shadow-200 light2 border-none\">Wallet / Utilisation</span></div>", 3)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            src: !!_unref(user).photo_url ? _unref(user).photo_url : '/assets/users_avatar/600w/user.jpg',
            width: "100%"
          }, null, 8, _hoisted_5)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _cache[0] || (_cache[0] = _createElementVNode("h3", { class: "mb-2" }, "C788PMKJ", -1)),
        _createElementVNode("h4", null, _toDisplayString(_unref(user).nom + ' ' + _unref(user).prenom), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("h4", _hoisted_8, _toDisplayString(_unref(user).collectivite?.nom), 1),
        _cache[1] || (_cache[1] = _createElementVNode("span", { class: "tag-state warning stroke" }, "En cours", -1)),
        _cache[2] || (_cache[2] = _createElementVNode("span", { class: "tag-state notif stroke" }, "Actif", -1))
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("h4", _hoisted_10, [
          _cache[3] || (_cache[3] = _createTextVNode(" Date de fin de souscription ", -1)),
          _cache[4] || (_cache[4] = _createElementVNode("br", { class: "mb-2" }, null, -1)),
          _createElementVNode("b", _hoisted_11, _toDisplayString(_unref(user).souscription ? _unref(formatDateFrench)(_unref(user).souscription.date_fin) : '-'), 1)
        ])
      ]),
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "s7_mobile h-100p px-5" }, [
        _createElementVNode("div", {
          class: "h-60 rounded-100 position-relative",
          style: {"width":"100%","background-color":"rgba(var(--color-black-rgb), 0.1)"}
        }, [
          _createElementVNode("div", { class: "widget-floating py-0 text-xl flex-right" }, "Utilisation"),
          _createElementVNode("div", {
            class: "h-100p flex align-items-center justify-content-left rounded-100 text-2xl px-5 bg-pop-green",
            style: {"width":"25%"}
          }, " 25% ")
        ])
      ], -1))
    ]),
    _cache[19] || (_cache[19] = _createElementVNode("div", { class: "clear-both h-20" }, null, -1)),
    _createElementVNode("div", _hoisted_12, [
      _cache[17] || (_cache[17] = _createElementVNode("div", { class: "s10 mt--4 ml--4 mb-5 collapse-open active" }, [
        _createElementVNode("span", { class: "px-5 py-4 bg-color-black rounded-100 text-xl" }, [
          _createElementVNode("img", {
            src: "/icons/icon-panel-open.svg",
            class: "size-xs icon-neutral mr-2 collapse-icon-open",
            alt: ""
          }),
          _createElementVNode("img", {
            src: "/icons/icon-panel-close.svg",
            class: "size-xs icon-neutral mr-2 collapse-icon-close",
            alt: ""
          }),
          _createTextVNode(" Décaissement mensuel ")
        ])
      ], -1)),
      (_unref(prelevements).length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [...(_cache[6] || (_cache[6] = [
            _createElementVNode("button", { class: "btn lg py-3 black active" }, [
              _createElementVNode("img", {
                src: "/icons/icon-pdf.svg",
                class: "btn-icon",
                alt: ""
              }),
              _createElementVNode("span", null, "Exporter en PDF")
            ], -1),
            _createElementVNode("button", { class: "btn lg py-3 black active" }, [
              _createElementVNode("img", {
                src: "/icons/icon-excel.svg",
                class: "btn-icon",
                alt: ""
              }),
              _createElementVNode("span", null, "Exporter en Excel")
            ], -1)
          ]))]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_14, [
        _cache[16] || (_cache[16] = _createElementVNode("div", { class: "clear-both h-15" }, null, -1)),
        (_unref(prelevements).length > 0)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _cache[12] || (_cache[12] = _createStaticVNode("<div class=\"flex items-center gap-6\"><div class=\"s7\"><h5 class=\"flex gap-3 secondary-font font-semibold text-grey-700\"><div class=\"circle-medium bg-color-1000\"></div> Débloqué </h5><h1 class=\"secondary-font font-semibold text-grey-900 my-2\">184 350 F</h1><h5 class=\"secondary-font font-semibold text-grey-700 mb-4\">+4.6%</h5><div class=\"h-40 rounded-100 position-relative overflow-hidden\" style=\"width:100%;background-color:rgba(var(--color-black-rgb), 0.1);\"><div class=\"h-100p flex align-items-center justify-content-left rounded-100 text-xl px-5 bg-color-1000 text-white\" style=\"width:4.6%;\"> 4.6% </div></div></div><div class=\"s7\"><h5 class=\"flex gap-3 secondary-font font-semibold text-grey-700\"><div class=\"circle-medium bg-purple\"></div> Bloqué </h5><h1 class=\"secondary-font font-semibold text-grey-900 my-2\">184 350 F</h1><h5 class=\"secondary-font font-semibold text-grey-700 mb-4\">95.4%</h5><div class=\"h-40 rounded-100 position-relative overflow-hidden\" style=\"width:100%;background-color:rgba(var(--color-black-rgb), 0.1);\"><div class=\"h-100p flex align-items-center justify-content-left rounded-100 text-xl px-5 bg-purple text-white\" style=\"width:95.4%;\"> 95.4% </div></div></div><div class=\"s6\"><h5 class=\"flex gap-3 secondary-font font-semibold text-grey-700\"><div class=\"circle-medium bg-green-light\"></div> Total </h5><h1 class=\"secondary-font font-semibold text-grey-900 my-2\">4 000 350 F</h1><h5 class=\"secondary-font font-semibold text-grey-700 mb-4\">100%</h5><div class=\"h-40 rounded-100 position-relative overflow-hidden\" style=\"width:100%;background-color:rgba(var(--color-black-rgb), 0.1);\"><div class=\"h-100p flex align-items-center justify-content-left rounded-100 text-xl px-5 bg-green-light\" style=\"width:100%;\"> 100% </div></div></div></div><div class=\"clear-both h-30\"></div>", 2)),
              _createElementVNode("div", _hoisted_15, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(prelevements), (prelevement, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["widget border border-3 shadow-200 rounded-30 gap-5 px-7 py-5", {'active': prelevement.status_prelevement == 'validated', 'opacity-6': prelevement.status_prelevement == 'pending'}]),
                    key: 'prelevement_' + index
                  }, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("h6", _hoisted_17, _toDisplayString(_unref(formatDateFrench)(prelevement.periode_prelevement)), 1),
                      _createElementVNode("h3", _hoisted_18, _toDisplayString(_unref(formatAmount)(prelevement.montant_prelevement_expected)) + " F", 1),
                      _cache[7] || (_cache[7] = _createElementVNode("p", { class: "secondary-font font-semibold text-purple" }, "1.5%", -1))
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("h5", _hoisted_20, _toDisplayString(prelevement.eta), 1),
                      (prelevement.status_prelevement == 'validated')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [...(_cache[8] || (_cache[8] = [
                            _createElementVNode("span", { class: "tag-state notif stroke" }, "Effectué", -1)
                          ]))]))
                        : _createCommentVNode("", true),
                      _cache[9] || (_cache[9] = _createElementVNode("p", { class: "secondary-font font-semibold text-grey-600 pt-1" }, "Date de déblocage", -1)),
                      _cache[10] || (_cache[10] = _createElementVNode("h6", { class: "secondary-font font-semibold text-grey-600 py-1" }, "11 Déc. 2025", -1))
                    ]),
                    (prelevement.active)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [...(_cache[11] || (_cache[11] = [
                          _createStaticVNode("<p class=\"s10 font-medium text-sm text-grey-600 mt-2\"> Prélèvement <span class=\"text-sm color-success\">(Effectué)</span></p><div class=\"s10\"><button class=\"btn-ultra w-100\"><div class=\"btn-show\"><img src=\"/icons/icon-valider.svg\" class=\"btn-icon\" alt=\"\"><span>Décaisser</span></div><div class=\"btn-loading\"><div class=\"loader-dots\"></div></div></button></div>", 2)
                        ]))]))
                      : _createCommentVNode("", true)
                  ], 2))
                }), 128))
              ]),
              _cache[13] || (_cache[13] = _createElementVNode("div", { class: "clear-both h-15" }, null, -1)),
              _cache[14] || (_cache[14] = _createElementVNode("span", { class: "px-5 py-4 bg-color rounded-100 font-bold text-lg collapse-open active align-right" }, [
                _createElementVNode("img", {
                  src: "/icons/icon-panel-open.svg",
                  class: "size-xs icon-neutral mr-2 collapse-icon-open",
                  alt: ""
                }),
                _createElementVNode("img", {
                  src: "/icons/icon-panel-close.svg",
                  class: "size-xs icon-neutral mr-2 collapse-icon-close",
                  alt: ""
                }),
                _createTextVNode(" Voir tous ")
              ], -1))
            ], 64))
          : _createCommentVNode("", true),
        (_unref(prelevements).length == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [...(_cache[15] || (_cache[15] = [
              _createElementVNode("h6", { class: "secondary-font font-semibold mb-1" }, "Aucun prélèvement trouvé", -1)
            ]))]))
          : _createCommentVNode("", true)
      ])
    ]),
    _cache[20] || (_cache[20] = _createElementVNode("div", { class: "clear-both h-80" }, null, -1))
  ]))
}
}

})